/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FiEdit, FiTrash2, FiEye, FiAlertTriangle, FiDatabase,
} from 'react-icons/fi';
import Button from '../../Shared/Button';
import { notify } from '../../Shared/toast';

const mockInventory = [
  {
    id: 'mock-1',
    name: 'Basmati Rice',
    nameBn: 'বাসমতি চাল',
    category: 'Grains',
    quantity: 15,
    unit: 'kg',
    sellingPrice: 120,
    minStockLevel: 10,
  },
  {
    id: 'mock-2',
    name: 'Chicken',
    nameBn: 'মুরগি',
    category: 'Meat',
    quantity: 8,
    unit: 'kg',
    sellingPrice: 180,
    minStockLevel: 5,
  },
];

function InventoryTable({
  items = [],
  // onEdit = () => {},
  onDelete = () => {},
  onView = () => {},
  className = '',
  isLoading = false,
  enableMockData = false,
}) {
  const [showMockData, setShowMockData] = useState(false);

  // Determine which items to display
  const shouldShowMockData = enableMockData && showMockData;
  const displayItems = shouldShowMockData ? mockInventory : items;
  const isEmpty = !displayItems || displayItems.length === 0;

  const getStockStatusClass = (quantity, minStockLevel) => {
    if (quantity === 0) return 'bg-red-100 text-red-800';
    if (quantity <= minStockLevel) return 'bg-yellow-100 text-yellow-800';
    return 'bg-green-100 text-green-800';
  };

  if (isLoading) {
    return (
      <div className={`bg-white shadow rounded-lg p-6 ${className}`}>
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-1/4 mb-4" />
          <div className="space-y-4">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={`skeleton-${i}`} className="h-12 bg-gray-100 rounded" />
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (isEmpty) {
    return (
      <div className={`bg-white shadow rounded-lg p-6 text-center ${className}`}>
        <p className="text-gray-500 mb-4">No inventory items found</p>
        {enableMockData && !shouldShowMockData && (
          <Button
            onClick={() => setShowMockData(true)}
            variant="outline"
            icon={<FiDatabase />}
          >
            Load Demo Data
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className={`bg-white shadow rounded-lg overflow-hidden ${className}`}>
      {shouldShowMockData && (
        <div className="bg-yellow-50 text-yellow-700 p-3 text-sm text-center border-b">
          Showing demo data -
          {' '}
          <button
            type="button"
            onClick={() => setShowMockData(false)}
            className="text-yellow-700 underline"
          >
            Switch to real data
          </button>
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          {/* Table headers */}
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Item</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Stock</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price (৳)</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>

          {/* Table body */}
          <tbody className="bg-white divide-y divide-gray-200">
            {displayItems.map((item) => {
              const isLowStock = item.quantity <= (item.minStockLevel || 5);
              const isOutOfStock = item.quantity === 0;

              return (
                <tr key={item.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      {isLowStock && !isOutOfStock && (
                        <FiAlertTriangle className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" />
                      )}
                      <div>
                        <div className="text-sm font-medium text-gray-900">{item.name}</div>
                        {item.nameBn && (
                          <div className="text-sm text-gray-500">{item.nameBn}</div>
                        )}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.category}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      getStockStatusClass(item.quantity, item.minStockLevel || 5)
                    }`}
                    >
                      {item.quantity}
                      {' '}
                      {item.unit || 'unit'}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    ৳
                    {(item.sellingPrice || 0).toFixed(2)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {isOutOfStock ? (
                      <span className="text-red-600 text-sm font-medium">Out of Stock</span>
                    ) : isLowStock ? (
                      <span className="text-yellow-600 text-sm font-medium">Low Stock</span>
                    ) : (
                      <span className="text-green-600 text-sm font-medium">In Stock</span>
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <button type="button" onClick={() => onView(item.id)} className="text-blue-950 hover:text-blue-600 mr-4">
                      <FiEye />
                    </button>
                    <button
                      type="button"
                      // onClick={() => onEdit(item)}
                      onClick={() => notify.info('Edit functionality is not implemented in this Demo version')}
                      className="text-indigo-900 hover:text-indigo-900 mr-4"
                    >
                      <FiEdit />
                    </button>
                    <button type="button" onClick={() => onDelete(item.id)} className="text-red-600 hover:text-red-900">
                      <FiTrash2 />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

InventoryTable.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      nameBn: PropTypes.string,
      category: PropTypes.string,
      quantity: PropTypes.number,
      unit: PropTypes.string,
      sellingPrice: PropTypes.number,
      minStockLevel: PropTypes.number,
    }),
  ),
  // onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onView: PropTypes.func,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  enableMockData: PropTypes.bool,
};

InventoryTable.defaultProps = {
  items: [],
  // onEdit: () => {},
  onDelete: () => {},
  onView: () => {},
  className: '',
  isLoading: false,
  enableMockData: false,
};

export default InventoryTable;
